/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/dashboard/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/dashboard/index
 * @description Implements the index interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Outlet, Route, Routes } from "react-router-dom";
import SellingProducts from "./selling-products";
import AdminDashboard from "./admin-dashboard";
import TopSellers from "./top-sellers";
import TopProducts from "./top-products";
import TopCustomers from "./top-customers";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
const dashboardBreadCrumbs: Array<PageLink> = [
    {
        title: 'UProcure',
        path: '/UProcure',
        isSeparator: false,
        isActive: false,
    },
    {
        title: 'Master',
        path: '/master-old',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
];
const UProcureDashboardIndex = () => (
    <>
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    index
                    element={
                        <>
                            <PageTitle breadcrumbs={dashboardBreadCrumbs}>
                                Dashboard
                            </PageTitle>
                            <AdminDashboard />
                        </>
                    }
                />
                <Route
                    path="/selling-products"
                    element={
                        <>
                            <PageTitle breadcrumbs={dashboardBreadCrumbs}>
                                Selling Products
                            </PageTitle>
                            <SellingProducts />
                        </>
                    }
                />
                <Route
                    path="/top-customers"
                    element={
                        <>
                            <PageTitle breadcrumbs={dashboardBreadCrumbs}>
                                Top Customers
                            </PageTitle>
                            <TopCustomers />
                        </>
                    }
                />
                <Route
                    path="/top-products"
                    element={
                        <>
                            <PageTitle breadcrumbs={dashboardBreadCrumbs}>
                                Top Products
                            </PageTitle>
                            <TopProducts />
                        </>
                    }
                />
                <Route
                    path="/top-sellers"
                    element={
                        <>
                            <PageTitle breadcrumbs={dashboardBreadCrumbs}>
                                Top Sellers
                            </PageTitle>
                            <TopSellers />
                        </>
                    }
                />
            </Route>
        </Routes>
    </>
);
export default UProcureDashboardIndex;
